export function emptyValidator(str) {
  if (!str) return "Input can't be empty";
  return "";
}
